import { RuleResult } from '../../../types/DeclarationP5'

export type FieldRequirement = 'required' | 'optional' | 'forbidden'

export type FieldRule = {
  requirement: FieldRequirement
  disabled?: boolean
  hidden?: boolean
}

export const DEFAULT_FIELD_RULE: FieldRule = {
  requirement: 'optional',
  disabled: false,
  hidden: false,
}

export const required = (): FieldRequirement => 'required'
export const forbidden = (): FieldRequirement => 'forbidden'
export const optional = (): FieldRequirement => 'optional'

export type FieldRequirementEnvironment<TContext> = {
  ctx: TContext
  getFieldRequirement: (path: string) => FieldRequirement | null
  ignoreServerRequirement: () => void
}

export type FieldRequirementResolver<TContext> = (env: FieldRequirementEnvironment<TContext>) => FieldRequirement

export type FieldRequirementResolverMap<TContext> = Record<string, FieldRequirementResolver<TContext>>

const childRequirementPrecedence: FieldRequirement[] = ['required', 'optional', 'forbidden']

export const ruleForChildRequirement = (
  parentRequirement: FieldRequirement,
  childRequirement: FieldRequirement,
) => (childRequirementPrecedence.indexOf(parentRequirement) > childRequirementPrecedence.indexOf(childRequirement)
  ? parentRequirement
  : childRequirement)

// forbidden > required > optional
const requirementPrecedence: FieldRequirement[] = ['optional', 'required', 'forbidden']

export const pickRule = (
  first: FieldRule,
  second: FieldRule,
) => (requirementPrecedence.indexOf(first.requirement) > requirementPrecedence.indexOf(second.requirement) ? first : second)

export function toFieldRequirement(ruleResult: RuleResult): FieldRequirement {
  switch (ruleResult) {
    case 'REQUIRED':
      return 'required'
    case 'NOT_ALLOWED':
      return 'forbidden'
    case 'OPTIONAL':
    default:
      return 'optional'
  }
}
